import React, { useRef, useState, useEffect } from 'react'
import './modalLibro.css';
import { useTranslation } from 'react-i18next'


const ifButton = (blog_gruid, idioma, titulo) => {
  const [t, i18n] = useTranslation("ideas_libertad");

  if (blog_gruid !== null) {
    console.log(blog_gruid);
    return <div class="buton_bp3_div"><a class="buton_bp3 espac" href={'/blog/' + blog_gruid}>{i18n.language === "en"
      ? "Read blog"
      : "Leer blog"} </a></div>;

  } else {
    if (titulo == 'Cómo pensar la economía' || titulo == 'How to Think About the Economy: A Primer') {
      console.log("Entro al libro");
      var blogtext2 = idioma == "es" ? "Descarga" : "Download";
      return <div class="buton_bp3_div"><a target="_blank" class="buton_bp3 espac" href={'https://play.google.com/store/books/details?id=Cdq-EAAAQBAJ&pli=1'}>{blogtext2} </a></div>;

    }
    else {
      return "";
    }

  }

};



const ModalLibro = ({ isOpen, closeModal, variable1, variable2, variable3, variable4, variable5, variable6, variable7, variable8, variable9, id_idea }) => {
  if (!isOpen) return null;

  const [shareOpen, setShareOpen] = useState(false);
  const desktopShareRef = useRef(null);
  const mobileShareRef = useRef(null);
  const triggerRef = useRef(null);
  const [t, i18n] = useTranslation("detail_blog");
  const shareUrl = window.location.origin +"/"+i18n.language+"/recomendados?libro="+id_idea;
  const shareTitle = variable3;



  useEffect(() => {

    const handleClickOutside = (event) => {

      const clickedDesktop =
        desktopShareRef.current &&
        desktopShareRef.current.contains(event.target);

      const clickedMobile =
        mobileShareRef.current &&
        mobileShareRef.current.contains(event.target);

      if (!clickedDesktop && !clickedMobile) {
        setShareOpen(false);
      }

    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };

  }, []);

  const shareToX = () => {
    window.open(
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`,
      "_blank"
    );
  };

  const shareToFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      "_blank"
    );
  };

  const shareToLinkedin = () => {
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      "_blank"
    );
  };

  const shareByEmail = () => {
    window.location.href =
      `mailto:?subject=${encodeURIComponent(shareTitle)}&body=${encodeURIComponent(shareUrl)}`;
  };

  const copyLink = async () => {

    try {

      await navigator.clipboard.writeText(shareUrl);

      alert(
        i18n.language === "en"
          ? "Link copied successfully"
          : "Liga copiada correctamente"
      );

    } catch (err) {

      console.error(err);

      alert(
        i18n.language === "en"
          ? "Could not copy the link"
          : "No se pudo copiar la liga"
      );

    }

  };

  return (
    <>
      <div className="modal_Lib  libreria_modal_desk">
        <div className="modalContent_Lib">

          <div className='row'>
            <div className='colum1_Libr_modal'>
              {/* <img class="imgG_bp" src={variable1} +{variable2} alt={"ejemplo"} /> */}
              <img className="imgG_modalLibro" src={variable1} alt={variable2} />


            </div>
            <div className='colum2_Libr_modal'>
              <div className='row_modal'>
                <h3 className='modal-title' > {variable3}</h3>
                <hr />
                <p className='card-text'> {variable4}</p>
              </div>
              <div className='row_modal2'>
                <div className='colum2_Libr_modal'>
                  <p className='datosLibr'> {variable5}</p>
                  <p className='datosLibr'> {variable6}</p>
                  <p className='datosLibr'> {variable7}</p>
                </div>

                <div class="_ngcontent-ng-c739792243 _nghost-ng-c4200879012 btn-share-blog">
                  <span class="click-tooltip">
                    <span
                      tabIndex="0"
                      role="button"
                      className="click-tooltip__trigger"
                    >
                      <div class="post-actions__group post-actions__group--share library-btn-share" aria-expanded={shareOpen}
                        ref={triggerRef}
                        onClick={() => setShareOpen(prev => !prev)}>
                        <img src="/assets/img2026/icon_share.svg" alt="Compartir en redes" aria-hidden="true" class="post-actions__icon post-actions__icon--share" />
                        <span class="post-actions__share-link">{(t('2026.compartir'))}</span>
                      </div>
                    </span>
                    {shareOpen && (
                      <span
                        className="click-tooltip__panel"
                        onClick={(e) => e.stopPropagation()}
                        ref={desktopShareRef}
                      >
                        <span role="tooltip" class="up-arrow click-tooltip__content">
                          <span class="click-tooltip__actions">
                            <button
                              type="button"
                              aria-label="Compartir en X"
                              className="click-tooltip__action"
                              onClick={shareToX}
                            >
                              <img
                                src="/assets/img2026/logo_twitter.svg"
                                alt="Compartir en X"
                                className="click-tooltip__icon click-tooltip__icon--x"
                              />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Facebook"
                              className="click-tooltip__action"
                              onClick={shareToFacebook}
                            >
                              <img src="/assets/img2026/logo_facebook.svg" alt="Compartir en Facebook" class="click-tooltip__icon click-tooltip__icon--facebook" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir por email"
                              className="click-tooltip__action"
                              onClick={shareByEmail}
                            >
                              <img src="/assets/img2026/icon_email.svg" alt="por email" aria-hidden="true" class="click-tooltip__icon click-tooltip__icon--email" />
                            </button>
                            <button
                              type="button"
                              aria-label="Compartir en Linkeding"
                              className="click-tooltip__action"
                              onClick={shareToLinkedin}
                            >
                              <img src="/assets/img2026/linkedin.svg" alt="Compartir en LinkedIn" class="click-tooltip__icon click-tooltip__icon--linkedin" />
                            </button>
                            <button
                              type="button"
                              aria-label="Copiar liga"
                              className="click-tooltip__action"
                              onClick={copyLink}
                            >
                              <img src="/assets/img2026/share.svg" alt="Copiar enlace" class="click-tooltip__icon click-tooltip__icon--share" />
                            </button>
                          </span>
                        </span>

                      </span>)}
                    {ifButton(variable8, variable9, variable3)}
                  </span>


                </div>


              </div>
            </div>
          </div>

          {/* <p>Variable 2: {variable2}</p> */}
          <button className="botonPop_Lib tache" onClick={closeModal}><span aria-hidden="true">×</span></button>

        </div >
        <div className="background_gri_Lib"></div>
      </div >
      <div class="_ngcontent-ng-c485834739 _nghost-ng-c1521374634 libreria_modal_movil">
        <div role="dialog" className="reflexion-image-modal">

          <section className="reflexion-image-modal__panel reflexion-image-modal__panel_img">

            <button
              type="button"
              className="reflexion-image-modal__close"
              onClick={closeModal}
            >
              ×
            </button>

            <header className="video-modal__header">
              <h2 id="video-modal-title" class="video-modal__title">{variable3}</h2>
            </header>

            <div className="video-modal__body">
              <div className="video-modal__content">

                <img
                  src={variable1}
                  alt={variable2}
                  className="video-modal__image"
                />

                <p className='mov-texto-b'> {variable4}</p>
                <div className='mov-detalles-b'>
                  <p> {variable5}</p>
                  <p> {variable6}</p>
                  <p> {variable7}</p>
                </div>

              </div>
            </div>
            <div className='div-compartir-idea-v'>

              {/* SHARE */}

              <span class="click-tooltip">
                <span
                  tabIndex="0"
                  role="button"
                  className="click-tooltip__trigger"
                  aria-expanded={shareOpen}
                  ref={triggerRef}
                  onClick={() => setShareOpen(prev => !prev)}
                >
                  <div class="post-actions__group post-actions__group--share library-btn-share">
                    <img
                      src="/assets/img2026/icon_share.svg"
                      alt="Compartir en redes"
                      aria-hidden="true"
                      class="post-actions__icon post-actions__icon--share"
                    />

                    <span class="post-actions__share-link">
                      {(t('2026.compartir'))}
                    </span>
                  </div>
                </span>

                {shareOpen && (
                  <span
                    className="click-tooltip__panel"
                    onClick={(e) => e.stopPropagation()}
                    ref={mobileShareRef}
                  >
                    <span role="tooltip" class="up-arrow click-tooltip__content">
                      <span class="click-tooltip__actions">
                        <button
                          type="button"
                          aria-label="Compartir en X"
                          className="click-tooltip__action"
                          onClick={shareToX}
                        >
                          <img
                            src="/assets/img2026/logo_twitter.svg"
                            alt="Compartir en X"
                            className="click-tooltip__icon click-tooltip__icon--x"
                          />
                        </button>
                        <button
                          type="button"
                          aria-label="Compartir en Facebook"
                          className="click-tooltip__action"
                          onClick={shareToFacebook}
                        >
                          <img src="/assets/img2026/logo_facebook.svg" alt="Compartir en Facebook" class="click-tooltip__icon click-tooltip__icon--facebook" />
                        </button>
                        <button
                          type="button"
                          aria-label="Compartir por email"
                          className="click-tooltip__action"
                          onClick={shareByEmail}
                        >
                          <img src="/assets/img2026/icon_email.svg" alt="Compartir por email" aria-hidden="true" class="click-tooltip__icon click-tooltip__icon--email" />
                        </button>
                        <button
                          type="button"
                          aria-label="Compartir en Linkeding"
                          className="click-tooltip__action"
                          onClick={shareToLinkedin}
                        >
                          <img src="/assets/img2026/linkedin.svg" alt="Compartir en LinkedIn" class="click-tooltip__icon click-tooltip__icon--linkedin" />
                        </button>
                        <button
                          type="button"
                          aria-label="Copiar liga"
                          className="click-tooltip__action"
                          onClick={copyLink}
                        >
                          <img src="/assets/img2026/share.svg" alt="Copiar enlace" class="click-tooltip__icon click-tooltip__icon--share" />
                        </button>
                      </span>
                    </span>
                  </span>
                )}

              </span>

              {ifButton(variable8, variable9, variable3)}

            </div>

          </section>
        </div>
      </div>
    </>
  );
};

export default ModalLibro;